// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*@import '../styles/base';*/\n/*.vdevice-not-xs .btn-df ::v-deep .v-btn__content{*/\n/*    font-size: 1.5rem;*/\n/*}*/\n/*.device-xs{*/\n/*    .myTable {*/\n/*        td {*/\n/*            padding: 0 6px;*/\n/*        }*/\n/*    }*/\n/*    .b {*/\n/*        font-size: 1.4em;*/\n/*    }*/\n/*}*/", ""]);
// Exports
module.exports = exports;
